module.exports = __webpack_public_path__ + "resources/ui-tab-line-bg2.38f0c267722da838.png";